export class Region {
    id: number;
    name:string;
    description: string;
    countryName: string;
    countryId:number;
    countryCode:string;
}